module.exports = __webpack_public_path__ + "img/samsung-A750F-A7-2018.5867da87.png";